import api from "./axiosInstance";

export interface ContactForm {
  name?: string;
  email: string;
  phone?: string;
}

export const FormAPI = {
  async submitContact(contact: ContactForm) {
    const response = await api.post('form', contact);
    return response.data;
  }
};
